import { render } from "./messageInput.vue?vue&type=template&id=2b562d40&scoped=true"
import script from "./messageInput.vue?vue&type=script&lang=js"
export * from "./messageInput.vue?vue&type=script&lang=js"

import "./messageInput.vue?vue&type=style&index=0&id=2b562d40&lang=scss&scoped=scoped"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b562d40"]])

export default __exports__